import { setCookie } from 'nookies'
import { useMutation, useQueryClient } from 'react-query'

import { EMAIL_STORAGE_KEY } from '~constants/storage.constants'
import { getEvaluation } from '~services/evaluations.service'

export const useConfirmPreviousEvaluationMutation = () => {
  const queryClient = useQueryClient()

  return useMutation(getEvaluation, {
    onSuccess: (evaluation) => {
      if (!evaluation.state) return

      queryClient.setQueryData(['evaluations', evaluation.email], evaluation)
      setCookie(null, EMAIL_STORAGE_KEY, evaluation.email, {
        maxAge: 30 * 24 * 60 * 60,
        path: '/',
      })
    },
  })
}
